import React from 'react'
import { Form, Input, Button, Avatar } from 'antd';
import { EditOutlined, UserOutlined } from '@ant-design/icons';

export default function Home() {
    return (
        <div className="container mt-5">
            <div className="row">
                <div className="col">
                    <div className="text-center mb-4 d-flex justify-content-between align-items-center flex-column flex-md-row gap-3">
                        <Avatar size={100} icon={<UserOutlined />} src="path_to_profile_image.jpg" />
                        <Button type="primary" icon={<EditOutlined />} className="ms-2">
                            Edit Profile
                        </Button>
                    </div>
                    <Form layout="vertical">
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Item label="First Name" name="firstName">
                                    <Input placeholder="Robert" size='large' />
                                </Form.Item>
                            </div>
                            <div className="col-md-6">
                                <Form.Item label="Last Name" name="lastName">
                                    <Input placeholder="Fox" size='large' />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Item label="Phone Number" name="phoneNumber">
                                    <Input placeholder="(252) 555-0126" size='large' />
                                </Form.Item>
                            </div>
                            <div className="col-md-6">
                                <Form.Item label="Email Address" name="email">
                                    <Input placeholder="robertfox@example.com" size='large' />
                                </Form.Item>
                            </div>
                        </div>
                        <Form.Item label="Address" name="address">
                            <Input.TextArea rows={2} placeholder="2464 Royal Ln. Mesa, New Jersey 45463" style={{ resize: "none" }} />
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    )
}
